
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Punetoaurangabadbushireonrent() {



  const cardData =
  {
    keyword: ' Pune to Aurangabad Bus Hire on Rent',
    heading: 'Vaishnavi Travels: Pune to Aurangabad Bus Hire on Rent',
    headingDescription: 'Vaishnavi Travels offers reliable and affordable Pune to Aurangabad Bus Hire on Rent, ideal for family tours, school excursions, religious yatras, and corporate outings. Our buses are well-maintained with spacious seating, strong air-conditioning, and ample luggage space, ensuring a smooth and comfortable ride on the Pune–Aurangabad route. With professional drivers, punctual service, and flexible booking options, we make long-distance travel stress-free and convenient. Whether it’s a visit to the Ajanta-Ellora Caves, Bibi Ka Maqbara, or a business trip, Vaishnavi Travels guarantees safe, reliable, and hassle-free bus rental services from Pune to Aurangabad.',

    top: 'Top Places to Visit in Aurangabad with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Ajanta Caves",
    "description": "The Ajanta Caves, a UNESCO World Heritage Site, are world-renowned rock-cut caves dating back to the 2nd century BCE. These 30 Buddhist caves showcase exquisite paintings, sculptures, and frescoes depicting the life of Buddha. The murals, considered masterpieces of ancient Indian art, still retain their vibrant colors. Visitors are mesmerized by the serenity and craftsmanship preserved in these caves. Surrounded by lush hills, the site is both spiritual and scenic. Ajanta Caves are Aurangabad’s crown jewel of heritage and artistry."
  },
  {
    "title": "Ellora Caves",
    "description": "Ellora Caves, another UNESCO World Heritage Site, consist of 34 caves representing Hindu, Buddhist, and Jain faiths. The highlight is the Kailasa Temple, carved out of a single rock, dedicated to Lord Shiva. Its massive scale and intricate carvings make it an architectural wonder of the world. Visitors also admire the peaceful Buddhist viharas and Jain temples. The caves reflect India’s religious harmony and artistic brilliance. Ellora is Aurangabad’s timeless monument of devotion and craftsmanship."
  },
  {
    "title": "Bibi Ka Maqbara",
    "description": "Often called the ‘Taj of the Deccan,’ Bibi Ka Maqbara was built in 1668 by Aurangzeb’s son, Azam Shah, in memory of his mother. Its white marble dome and Mughal gardens resemble the Taj Mahal but with Deccan influences. Tourists enjoy strolling through the symmetrical pathways and admiring its intricate carvings. Illuminated at night, it offers a mesmerizing view. It is the most photographed monument of Aurangabad. Bibi Ka Maqbara is Aurangabad’s iconic Mughal-era masterpiece."
  },
  {
    "title": "Daulatabad Fort",
    "description": "Daulatabad Fort, located 15 km from Aurangabad, is one of India’s most formidable forts. Built on a conical hill, it features complex defense mechanisms like false gates, moats, and steep pathways. Once the capital of Tughlaq dynasty under Muhammad bin Tughlaq, it boasts a fascinating history. Tourists love climbing to the top for panoramic views of the surroundings. Its Chand Minar and rock-cut passages are architectural highlights. Daulatabad is Aurangabad’s proud fortress of strength and strategy."
  },
  {
    "title": "Aurangabad Caves",
    "description": "Aurangabad Caves, carved between the 6th and 8th centuries, are a group of 12 Buddhist caves located close to the city. They feature intricate carvings, Chaitya halls, and Viharas with stunning sculptures of Buddha and Bodhisattvas. The caves offer both historical significance and panoramic views of the city below. They remain a less-crowded alternative to Ajanta and Ellora, making them peaceful to explore. Aurangabad Caves are the city’s hidden spiritual and artistic heritage."
  },
  {
    "title": "Panchakki",
    "description": "Panchakki, or the water mill, is a 17th-century marvel built to generate energy for grinding grains for pilgrims and soldiers. Its underground water channel, sourced from a spring 6 km away, still astonishes visitors with its engineering. The site also houses a garden, mosque, and dargah. Tourists love its calm ambiance and historical charm. It is an excellent example of Mughal-era water management. Panchakki is Aurangabad’s blend of science, history, and spirituality."
  },
  {
    "title": "Grishneshwar Jyotirlinga Temple",
    "description": "Grishneshwar Temple, located near Ellora, is one of the 12 Jyotirlingas of Lord Shiva. Reconstructed in the 18th century by Ahilyabai Holkar, it showcases beautiful red-stone carvings and sculptures. Devotees believe visiting this shrine grants immense blessings. The temple’s serene environment attracts both pilgrims and history lovers. During Shivratri, it witnesses massive celebrations. Grishneshwar is Aurangabad’s sacred jewel of devotion and heritage."
  },
  {
    "title": "Salim Ali Lake and Bird Sanctuary",
    "description": "Named after India’s famous ornithologist, Salim Ali Lake and Bird Sanctuary is a peaceful retreat in Aurangabad. The lake, once part of the Mughal gardens, now attracts migratory birds like flamingos, cranes, and herons. Birdwatchers and nature lovers find it a paradise, especially in winter. The lush greenery and calm waters make it a family-friendly outing spot. It combines natural beauty with eco-tourism. Salim Ali Bird Sanctuary is Aurangabad’s green escape for bird lovers."
  },
  {
    "title": "Himayat Bagh",
    "description": "Himayat Bagh is a 17th-century Mughal garden spread over 300 acres, once part of the Nizam’s palace. Today, it houses a fruit research station and nurseries. Its lush greenery, fountains, and serene pathways make it perfect for leisurely strolls. Tourists enjoy exploring its Mughal-era charm combined with modern horticulture. It is less crowded, ideal for peaceful relaxation. Himayat Bagh is Aurangabad’s refreshing heritage garden."
  },
  {
    "title": "Goga Baba Hill",
    "description": "Goga Baba Hill is a scenic spot in Aurangabad offering panoramic views of the city. The hilltop has a small temple and is popular among locals for morning walks and trekking. At sunset, it provides breathtaking views of the horizon and city lights. The peaceful surroundings make it a hidden retreat within the city. Fitness enthusiasts enjoy the climb, while tourists appreciate the natural setting. Goga Baba Hill is Aurangabad’s peaceful blend of spirituality and nature."
  }
],

"services": [
{
"name": "Aurangabad Bus Booking Pune",
"description": "Efficient and reliable bus booking services from Pune to Aurangabad for all kinds of travel needs including family trips, corporate tours, and group outings. We offer a variety of buses including AC and non-AC options with professional drivers ensuring timely pickups and comfortable journeys. Our user-friendly booking process guarantees hassle-free reservations."
},
{
"name": "AC Bus Hire to Aurangabad",
"description": "Comfortable air-conditioned bus rentals from Pune to Aurangabad, ideal for long-distance travel with climate-controlled interiors. These buses provide plush seating, ample luggage space, and onboard amenities to ensure a relaxing trip. Perfect for corporate groups, family tours, and special occasions, ensuring a cool and pleasant journey regardless of weather."
},
{
"name": "Non AC Bus Pune to Aurangabad",
"description": "Affordable non-AC bus rental options for travel from Pune to Aurangabad, suitable for budget-conscious travelers and group tours. Despite the economical pricing, these buses maintain high safety standards and comfortable seating for a pleasant journey. Ideal for short-distance travel, school trips, and casual outings."
},
{
"name": "Ajanta-Ellora Tour Bus Pune",
"description": "Specialized bus services for sightseeing tours from Pune to the Ajanta and Ellora caves near Aurangabad. Our buses are equipped to handle group tours, providing ample space for passengers and luggage, with knowledgeable drivers familiar with the route. Enjoy a comfortable and scenic journey to these UNESCO World Heritage Sites."
},
{
"name": "Group Trip Bus to Aurangabad",
"description": "Customized group travel bus hire from Pune to Aurangabad for families, friends, and corporate teams. These buses accommodate medium to large groups with spacious seating and onboard entertainment options. Flexible pickup times and routes ensure your group travels together smoothly and comfortably."
},
{
"name": "Pune to Aurangabad Outstation Bus",
"description": "Reliable outstation bus service covering travel between Pune and Aurangabad with experienced drivers, well-maintained vehicles, and flexible scheduling. Ideal for business trips, pilgrimages, and leisure travel with a range of bus sizes to fit your group’s needs and preferences."
},
{
"name": "Corporate Tour Aurangabad Bus",
"description": "Professional corporate bus rental services for business tours and meetings from Pune to Aurangabad. These buses offer comfortable seating, Wi-Fi options, and punctual services tailored to corporate schedules. Enhance team travel with our premium vehicles and courteous drivers."
},
{
"name": "Family Travel Bus Aurangabad",
"description": "Family-friendly bus hire from Pune to Aurangabad offering safe, spacious, and comfortable vehicles perfect for family outings, reunions, and vacations. Our drivers prioritize passenger safety and convenience, ensuring a smooth and enjoyable trip for all age groups."
},
{
"name": "40 Seater Aurangabad Bus Hire",
"description": "Spacious 40-seater buses available for Pune to Aurangabad travel, accommodating large groups with comfort and ample luggage space. Suitable for weddings, corporate events, and group tours, these buses are equipped with modern amenities and driven by experienced professionals."
},
{
"name": "School Trip Bus to Aurangabad",
"description": "Safe and reliable school trip bus rental from Pune to Aurangabad, designed with student safety and comfort in mind. Our buses come with trained drivers, clean interiors, and sufficient space for groups, making them ideal for educational tours and excursions to historical sites."
},
{
"name": "Heritage Tour Bus Hire Pune",
"description": "Dedicated heritage tour bus services from Pune to Aurangabad focusing on historical and cultural excursions including visits to monuments, caves, and museums. These buses are well-equipped for long travel durations and provide a comfortable experience for tourists and history enthusiasts."
},
{
"name": "Aurangabad Bus with Driver",
"description": "Convenient bus rentals with professional drivers for Pune to Aurangabad trips, ensuring safe navigation on long routes and local expertise. Drivers are courteous, punctual, and experienced in handling diverse travel needs from sightseeing tours to corporate trips."
},
{
"name": "Book Aurangabad Bus Online Pune",
"description": "Easy and secure online booking platform for bus rentals from Pune to Aurangabad, allowing customers to choose from a variety of buses, compare prices, and confirm bookings instantly. Features include digital payments, customer support, and real-time updates for a seamless reservation experience."
}
],
"tableData": [
["Aurangabad Bus Booking Pune", "AC Bus Hire to Aurangabad"],
["Non AC Bus Pune to Aurangabad", "Ajanta-Ellora Tour Bus Pune"],
["Group Trip Bus to Aurangabad", "Pune to Aurangabad Outstation Bus"],
["Corporate Tour Aurangabad Bus", "Family Travel Bus Aurangabad"],
["40 Seater Aurangabad Bus Hire", "School Trip Bus to Aurangabad"],
["Heritage Tour Bus Hire Pune", "Aurangabad Bus with Driver"],
["Book Aurangabad Bus Online Pune"]
],




"whychoose": [
  {
    "WhyChooseheading": "Trusted Pune to Aurangabad Bus Hire on Rent",
    "WhyChoosedescription": "Vaishnavi Travels offers reliable and affordable bus hire services from Pune to Aurangabad, ideal for group travel and special occasions."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Seating",
    "WhyChoosedescription": "Our buses provide ample legroom and cushioned seats to ensure a pleasant journey to Aurangabad for all passengers."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Each bus is regularly serviced and thoroughly cleaned to maintain high standards of safety and hygiene."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages for Pune to Aurangabad Trips",
    "WhyChoosedescription": "Choose from hourly, daily, or multi-day rental options tailored to your travel plans and group size."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Pune-Aurangabad Route",
    "WhyChoosedescription": "Our professional drivers ensure safe, timely, and courteous service with expert knowledge of the Pune to Aurangabad route."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy all-inclusive pricing covering fuel, tolls, taxes, and driver allowances for a hassle-free rental experience."
  },
  {
    "WhyChooseheading": "Ideal for Corporate Events, Pilgrimage Tours, and Group Travel",
    "WhyChoosedescription": "Perfect for corporate trips, religious tours, sightseeing, and group outings between Pune and Aurangabad."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Vaishnavi Travels provides round-the-clock assistance to help with bookings, itinerary changes, and travel inquiries."
  }
]























  }








const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels provide bus hire services from Pune to Aurangabad?',
      answer: 'Yes, Vaishnavi Travels offers dependable bus hire services from Pune to Aurangabad, suitable for group tours, corporate travel, family outings, and pilgrimage trips.',
    },
    {
      question: 'What types of buses are available for Pune to Aurangabad trips?',
      answer: 'We provide a range of options including 32 seater tempo travellers, 40 to 50 seater coaches, both AC and non-AC, to cater to various group sizes and comfort preferences.',
    },
    {
      question: 'What is the approximate cost for hiring a bus from Pune to Aurangabad?',
      answer: 'Rental rates typically start from ₹9,000 for a one-day trip with a 32 seater tempo traveller, but exact prices depend on bus type and trip duration. Customized quotes are provided upon request.',
    },
    {
      question: 'Are drivers included in the bus hire service?',
      answer: 'Yes, all bookings include experienced and licensed drivers familiar with the Pune-Aurangabad route to ensure a safe and smooth journey.',
    },
    {
      question: 'Can the itinerary be customized for the Aurangabad trip?',
      answer: 'Absolutely. We can tailor the schedule and stops according to your group’s preferences and sightseeing plans.',
    },
    {
      question: 'How far in advance should I book a bus from Pune to Aurangabad?',
      answer: 'Booking 3-5 days in advance is advisable, especially during peak travel seasons and weekends, to secure availability.',
    },
    {
      question: 'Are tolls, parking, and other charges included in the rental fare?',
      answer: 'Tolls, parking fees, driver allowances, and any permits are typically extra and will be clearly outlined in your rental quote.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Rajesh Kulkarni",
    position: "Travel Coordinator",
    feedback:
      "We hired a 40 seater AC bus from Vaishnavi Travels for our Pune to Aurangabad trip. The bus was comfortable, clean, and the driver was punctual and courteous. The entire experience was hassle-free and pleasant.",
    rating: 5,
  },
  {
    name: "Mrs. Kavita Deshmukh",
    position: "Family Organizer",
    feedback:
      "Vaishnavi Travels provided excellent service for our group trip to Aurangabad. The tempo traveller was spacious and well-maintained. The driver was very professional and ensured a smooth journey. Highly recommended!",
    rating: 5,
    style: "style-2",
  }
];























































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Aurangabad Bus Hire on Rent",
  "image": "https://vaishnavitravel.com/assets/images/pune-to-aurangabad-bus.jpg",
  "description": "Book Pune to Aurangabad bus hire with Vaishnavi Travels for comfortable AC and Non AC buses ideal for group trips, corporate tours, heritage visits, and family travel.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.82",
    "ratingCount": "1350"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4200",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/pune-to-aurangabad-bus-hire-on-rent"
  }
};


  return (
    <div>

<Helmet>
  <title>Pune to Aurangabad Bus Hire on Rent | AC & Non AC Bus Services | Vaishnavi Travels</title>
  <meta
    name="description"
    content="Book Pune to Aurangabad bus hire with Vaishnavi Travels for comfortable AC and Non AC buses ideal for group trips, corporate tours, heritage visits, and family travel."
  />
  <meta
    name="keywords"
    content="Aurangabad Bus Booking Pune, AC Bus Hire to Aurangabad, Non AC Bus Pune to Aurangabad, Ajanta-Ellora Tour Bus Pune, Group Trip Bus to Aurangabad, Pune to Aurangabad Outstation Bus, Corporate Tour Aurangabad Bus, Family Travel Bus Aurangabad, 40 Seater Aurangabad Bus Hire, School Trip Bus to Aurangabad, Heritage Tour Bus Hire Pune, Aurangabad Bus with Driver, Book Aurangabad Bus Online Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/27.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoaurangabadbushireonrent;